var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Flex } from "../..";
/**
 * Manages the layout of the immediate children along the vertical or horizontal axis,
 * with optional spacing between the children.
 *
 * @param {{
 *  direction?: import("csstype").Property.FlexDirection | Array<import("csstype").Property.FlexDirection | null>;
 *  spacing?: number | Array<number | null>;
 *  alignItems?: import("csstype").Property.AlignItems | Array<import("csstype").Property.AlignItems>;
 *  justifyContent?: import("csstype").Property.JustifyContent | Array<import("csstype").Property.JustifyContent>;
 *  [x: string]: any;
 *  children: React.ReactNode;
 * }} props
 * @returns
 */
export default function Stack(_a) {
    var { direction = "column", spacing = 3, alignItems, justifyContent, children } = _a, rest = __rest(_a, ["direction", "spacing", "alignItems", "justifyContent", "children"]);
    return (_jsx(Flex, Object.assign({ gap: spacing, direction: direction, sx: { alignItems, justifyContent } }, rest, { children: children })));
}
//# sourceMappingURL=Stack.js.map